import VueI18n from '../plugins/i18n';

export const availabilityOptions = () => {
  const options = [
    VueI18n.t('statics.availabilityOptions.available'),
    VueI18n.t('statics.availabilityOptions.notAvailable'),
  ];
  return options;
};
